<template>
  <div class="trajectory-wrap" :style="{ minWidth: option.width }">
    <ul class="trajectory-head-list row-list">
      <li
        v-for="(item, index) in option.head"
        class="trajectory-head-item col-item"
        :key="index"
        :style="{ width: '100px', ...(item.style || {}) }"
      >
        <slot v-if="item.slotTitle" :name="`${item.prop}SlotTitle`" :item="item" />
        <span v-else>{{ item.label || '' }}</span>
      </li>
    </ul>
    <ul class="trajectory-body-list">
      <li
        v-for="(trackItem, trackIndex) in trackList"
        class="trajectory-body-item"
        :key="trackIndex"
      >
        <ul class="row-list">
          <li
            v-for="(item, index) in option.head"
            class="col-item"
            :key="index"
            :style="{ width: '100px', ...(item.style || {}) }"
          >
            <slot v-if="item.slot" :name="`${item.prop}Slot`" :item="trackItem" :index="index" />
            <template v-else-if="item.prop === 'showImg'">
              <span
                v-if="(Number(trackItem.remark2) === 1 && [100, 110, 120, 10, 94].includes(trackItem.code)) || (Number(trackItem.pictureFlag) === 1 && [90, 91, 92, 2,20].includes(trackItem.code))"
                class="link-color pointer-view"
                @click="getImgUrl(trackItem)"
              >{{ $lang('查看') }}</span>
            </template>
            <template v-else-if="item.prop === 'scanNetworkName'">
              <el-tooltip
                effect="dark"
                trigger="click"
                placement="top"
                :disabled="!option.showNetInfo"
              >
                <div slot="content">
                  <div>{{$lang('网点客服')}}: {{ trackItem.customerServicePrincipal }}</div>
                  <div>{{$lang('联系方式')}}: {{ trackItem.customerServiceTelephone }}</div>
                  <template v-if="trackItem.isLatestTrack && trackItem.isAbnormal === 1">
                    <div>{{$lang('异常类型')}}: {{trackItem.abnormalTypeName}}</div>
                    <div>{{$lang('异常原因')}}: {{trackItem.abnormalCauses}}</div>
                    <!-- <div>{{$lang('解决时间')}}: {{trackItem.estimateTime}}</div> -->
                    <div>{{$lang('应对话术')}}: {{trackItem.speechcraft}}</div>
                    <div>{{$lang('异常解决方案')}}: {{trackItem.solution}}</div>
                    <div v-if="option.copyBtn" style="text-align: center; margin-top: 5px">
                      <el-button
                        type="primary"
                        @click="handleCopy(trackItem.speechcraft)"
                      >{{ $lang('复制') }}</el-button>
                    </div>
                  </template>
                </div>
                <div :class="{ [markClassMap[trackItem.colorLabel]]: trackItem.isLatestTrack && trackItem.isAbnormal === 1 }">
                  <span v-if="typeof item.formatter==='function'">{{ item.formatter(trackItem) }}</span>
                  <span v-else>{{ trackItem[item.prop] }}</span>
                </div>
              </el-tooltip>
            </template>
            <template v-else-if="item.prop === 'waybillTrackingContent'">
              <div class="track-wrapper">
                <TrajectoryContent :key="index" :trackData="trackItem" :markClassMap="markClassMap" :option="option" />
                <el-link
                  v-if="trackItem.waybillTrackingContent && option.showCopyTrail"
                  type="primary"
                  class="copy-show"
                  @click="handleCopy(trackItem.waybillTrackingContent)"
                >
                  {{$lang('复制')}}
                </el-link>
              </div>
            </template>
            <template v-else-if="typeof item.formatter==='function'">
              <span v-if="item.html" v-html="item.formatter(trackItem)" />
              <span v-else>{{item.formatter(trackItem)}}</span>
            </template>
            <span v-else>{{ trackItem[item.prop] }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import TrajectoryContent from './TrajectoryContent'
import { detailView } from '../pool'
import { copyText, imgRegular } from '@/common/utils/tool'

export default {
  name: 'TrajectoryRecord',
  components: [TrajectoryContent],
  props: {
    trackList: {
      type: Array,
      default: () => []
    },
    trailErrorMsg: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      markClassMap: {
        1: 'mark-color-red',
        2: 'mark-color-blue',
        3: 'mark-color-green'
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    getImgUrl(item) {
      detailView.getImageList({
        waybillNo: item.waybillNo,
        scanTime: item.scanTime,
        scanByCode: item.scanByCode,
        imgType: item.imgType
      }).then(({ data }) => {
        this.handleShowImg(data || [])
      })
    },
    handlePopoverInfo(item, index) {
      this.popIndex = -1
      detailView.reqNetworkInfo({ networkId: item.scanNetworkId }).then(({ data }) => {
        this.infoData = data || {}
        this.popIndex = index
      })
    },
    handleCopy(val) {
      copyText(val)
    },
    handleShowImg(url = []) {
      const imgs = url.filter(o => o.match(imgRegular))
      this.$openImagePreview(imgs)
      url.map(file => {
        if (!file.match(imgRegular)) {
          // window.open(file)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .trajectory-wrap {
    border: 1px solid;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    overflow: hidden;
    box-sizing: border-box;
    @include border-color('lighter');
    ul, li {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .row-list {
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: stretch;

      .col-item {
        word-break: break-all;
        white-space: normal;
        padding: 10px;
        border-left: 1px solid;
        border-top: 1px solid;
        @include border-color('lighter');
        &:first-child {
          border-left: none;
        }
        .icon-eyes {
          cursor: pointer;
          margin-left: 10px;
        }
        .track-wrapper {
          .copy-show {
            font-size: 12px;
            display: none;
            line-height: 12px;
          }
          &:hover {
            .copy-show {
              display: inline-block;
            }
          }
        }
      }
    }
    .trajectory-head-list {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 40px;
      height: 40px;
      font-size: 14px;
      line-height: 20px;
      @include bg-color('pop-active');
      @include text-color('main');
      .trajectory-head-item {
        text-align: center;
        border-top: none !important;
      }
    }
    .trajectory-body-list {
      font-size: 12px;
      line-height: 16px;
      .trajectory-body-item {
        @include text-color('routine');
      }
    }
    ::v-deep {
      .mark-color-red {
        color: #fb0000;
      }
      .mark-color-blue {
        color: blue;
      }
      .mark-color-green {
        color: green;
      }
    }
  }
</style>
